// @flow
import * as React from "react";
import styled from "styled-components";
import Media from "react-media";

import ClickOutside from "../../common/ClickOutside";
import Gettext, { withGettext } from "../../common/Gettext";

import SearchLogic from "../SearchLogic";
import { UnitedSearchIcon, UnitedSearchCloseIcon as CloseIcon } from "../Icons";

const Container = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex: 1;
  height: 100%;
  color: rgba(255, 255, 255, 0.5);
`;

const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  width: calc(100% - 20px);
  margin-left: 20px;
  font-weight: 400;
  font-size: 16px;
  line-height: 2;
  box-shadow: inset 0px -1px 0px 0px rgba(255, 255, 255, 0.5);

  @media (max-width: 959px) {
    padding: 8px 0;
  }
`;

const Search = styled.span`
  direction: ${props => props.theme.direction};
`;

const SearchInput = styled.input`
  display: flex;
  flex-grow: 1;
  padding: 0 10px;
  margin: 0;
  box-sizing: border-box;
  font-weight: 400;
  font-size: 16px;
  font-family: Roboto, Arial, sans-serif;
  color: #fff;
  background-color: transparent;
  border: none;
  appearance: none;

  :focus {
    outline: none;
  }

  ::-webkit-search-decoration,
  ::-webkit-search-cancel-button,
  ::-webkit-search-results-button,
  ::-webkit-search-results-decoration {
    appearance: none;
  }

  @media (max-width: 959px) {
    padding: 0;
  }
`;

const Button = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  height: 100%;
  padding: 0 10px;
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "12px"};
  line-height: 1;
  text-align: center;
  text-decoration: none;

  @media (max-width: 959px) {
    margin-left: 10px;
    margin-right: 10px;
  }

  @media (min-width: 960px) {
    font-size: ${({ theme }) =>
      theme.locale === "ar" ? theme.minFontSize : "14px"};
    margin-left: 10px;
    margin-right: 10px;
  }
`;

type Props = {
  gettext: Function,
  children: React.Node
};

type State = {
  isSearchActive: boolean
};

function SearchButton(props: {}) {
  return (
    <Button {...props}>
      <UnitedSearchIcon />
    </Button>
  );
}

class UnitedSearch extends React.Component<Props, State> {
  state = {
    isSearchActive: false
  };

  toggleSearch = () => {
    this.setState({
      isSearchActive: !this.state.isSearchActive
    });
  };

  hideSearch = () => {
    this.setState({
      isSearchActive: false
    });
  };

  render() {
    if (this.state.isSearchActive === true) {
      return (
        <SearchLogic key="searchheader">
          {({
            inputFieldRef,
            searchQuery,
            updateSearchQuery,
            redirectToSearch,
            redirectOnEnter
          }) => (
            <React.Fragment>
              <ClickOutside onOutsideClick={this.toggleSearch}>
                {({ innerRef }) => (
                  <Container ref={innerRef}>
                    <SearchContainer>
                      <Media
                        query="(min-width: 960px)"
                        render={() => (
                          <Search>
                            <Gettext>Search</Gettext>:
                          </Search>
                        )}
                      />
                      <SearchInput
                        ref={inputFieldRef}
                        type="search"
                        aria-label="Search helpdesk"
                        id="helpdesk-search-header"
                        name="helpdesk-search-header"
                        placeholder={this.props.gettext`Search`}
                        value={searchQuery}
                        onChange={e => updateSearchQuery(e)}
                        onKeyDown={e => redirectOnEnter(e, "header")}
                      />
                      <CloseIcon onClick={this.toggleSearch} />
                    </SearchContainer>
                  </Container>
                )}
              </ClickOutside>
              <SearchButton
                onClick={() => {
                  this.hideSearch();
                  redirectToSearch("header");
                }}
              />
            </React.Fragment>
          )}
        </SearchLogic>
      );
    }

    return (
      <React.Fragment>
        {this.props.children}
        <SearchButton onClick={this.toggleSearch} />
      </React.Fragment>
    );
  }
}

export default withGettext(UnitedSearch);



// WEBPACK FOOTER //
// ./src/components/Helpdesk/Header/Search.js